export default {
  data() {
    return {
      allSelectionData: [],
      key: 'spuId'
    }
  },
  computed: {
    flatSelectionData() {
      let arr = this.allSelectionData;
      let arrIds = Array.from(new Set(arr.map(v=>v.spuId)));
      let newArr = [];
      arrIds.forEach(id=>{
        newArr.push(arr.find(v=>v.spuId === id));
      })
      return newArr;
    }
  },
  methods: {
    handleTagClose(item) {
      this.allSelectionData = this.allSelectionData.filter(v=>v.spuId !== item.spuId);
      this.cancelCheckedNode(item);
    },
    // check change
    handleSelect(data, row) {
      let currentData = this.allSelectionData;
      
      const checkStatus = !currentData.find(v=>v.spuId === row.spuId);
      if(checkStatus){
        // 勾选
        this.allSelectionData = [...currentData, ...data];
      }else{
        // 取消勾选
        currentData = currentData.filter(v=>v.spuId !== row.spuId);
        this.allSelectionData = currentData;
      }
    },
    // check change
    handleSelectAll(data) {
      let currentData = this.allSelectionData;
      if(data.length === 0) {
        let clearData = this.tableData;
        let checkedData = currentData.filter(v=>!clearData.find(k=>k.spuId===v.spuId))
        this.allSelectionData = checkedData
      }else{
        this.allSelectionData = [...currentData, ...data]
      }
    },
    // 回显已选中节点
    showCheckedNode() {
      this.$nextTick(_=>{
        const data = this.tableData.filter(v=>this.flatSelectionData.find(k=>k.spuId===v.spuId))
        data.forEach(row=>{
          this.$refs.elTable.toggleRowSelection(row)
        })
      })
    },
    // 取消勾选已关闭节点
    cancelCheckedNode(row) {
      const data = this.tableData.filter(v=>row.spuId===v.spuId)[0]
      this.$refs.elTable.toggleRowSelection(data)
    }
  }
}